var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"id":"router-view"}}),_c('Transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.isloading),expression:"this.isloading"}],staticClass:"loading"},[_c('div',{staticClass:"spinner"}),_c('div',{staticClass:"label"},[_vm._v("Lade Daten...")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }